/**
 * 定义Method的类型
 * @param method:method
 */

export default {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
};


// WEBPACK FOOTER //
// ./src/resource-api/core/method.js